import React from "react";
import { BsCaretDownFill as DownIcon } from "@react-icons/all-files/bs/BsCaretDownFill";
import { BsCaretUpFill as UpIcon } from "@react-icons/all-files/bs/BsCaretUpFill";
import { ButtonV2 } from "@Modules/common/ButtonV2";

import { classNames } from "repoV2/utils/common/render/classNames";

import styles from "./ExpandCollapseButton.module.scss";

const ExpandCollapseButton = ({
    expanded,
    expandDirection = "down",
    toggleState,
    text,
}: {
    expanded: boolean;
    expandDirection: "down" | "up";
    toggleState: () => void;
    text: string;
}) => {
    let iconComponent = null;

    if (expandDirection === "down") {
        iconComponent = expanded ? <UpIcon /> : <DownIcon />;
    } else {
        iconComponent = expanded ? <DownIcon /> : <UpIcon />;
    }

    return (
        <ButtonV2
            design="plain"
            className={classNames(
                expanded ? styles.expanded : styles.collapsed,
                "d-flex align-items-center p-0"
            )}
            onClick={toggleState}
        >
            {text}&nbsp;
            {iconComponent}
        </ButtonV2>
    );
};

export default ExpandCollapseButton;
